/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserPointsOptionRespVo
 */
export interface GetUserPointsOptionRespVo {
    /**
     * 编号
     * @type {number}
     * @memberof GetUserPointsOptionRespVo
     */
    code?: number;
    /**
     * 名称
     * @type {string}
     * @memberof GetUserPointsOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the GetUserPointsOptionRespVo interface.
 */
export function instanceOfGetUserPointsOptionRespVo(value: object): value is GetUserPointsOptionRespVo {
    return true;
}

export function GetUserPointsOptionRespVoFromJSON(json: any): GetUserPointsOptionRespVo {
    return GetUserPointsOptionRespVoFromJSONTyped(json, false);
}

export function GetUserPointsOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPointsOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetUserPointsOptionRespVoToJSON(json: any): GetUserPointsOptionRespVo {
    return GetUserPointsOptionRespVoToJSONTyped(json, false);
}

export function GetUserPointsOptionRespVoToJSONTyped(value?: GetUserPointsOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

